"use strict";

Shopify.theme.jsProcessTimeline = {

    init: function init($section) {

        Shopify.theme.jsProcessTimeline = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
        if (!$section.hasClass('tab-active')) {
            return
        }
        let parent = document.querySelector('li.timeline--item a').parentElement;

        while (parent) {
            const hasOverflow = parent.style.overflow;
            if (hasOverflow !== 'visible') {
                $(parent).css('overflow', 'unset')
                //                 console.log(hasOverflow, parent);
            }
            parent = parent.parentElement;
        }
        this.initTimeline($section)
    },
    resetTop: function resetTop() {
        $(".timeline--item a").css('top', 0)
    },
    navList: function navList($section) {
        let navlist = []
        if (!$section) {
            return []
        }
        $section.find(".timeline--item a").each(function(i) {
            var thisLink = $(this);
            var thisId = thisLink.attr('href');
            var thisTarget = $(thisId);
            var height = thisTarget.outerHeight()
            thisLink.parent().css('height', height)

            navlist.push({
                'anchor': thisLink,
                'id': thisId,
                'target': thisTarget
            });
        });
        return navlist
    },
    initTimeline: function initTimeline($section) {
        $section.find('timeline--item a').on('click', function(e) {
            let $link = $(this)
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $(`#${$link.attr('href')}`).offset().top - $('#mobile-header').height()
            }, 800);
        });



        Shopify.theme.jsProcessTimeline.updateHash($section)
        Shopify.theme.horizontalScrollBar.updateValues()
        $(window).on('scroll resize', function(e) {
            //           requestAnimationFrame(moveAnimation)
            Shopify.theme.horizontalScrollBar.updateValues()
            Shopify.theme.jsProcessTimeline.updateHash($section)
        })

        function moveAnimation() {
            Shopify.theme.horizontalScrollBar.updateValues()
            Shopify.theme.jsProcessTimeline.updateHash($section)
        }
        //             //if($section.offset().top+$section.height()<$(window).scrollTop){
        //              Shopify.theme.horizontalScrollBar.updateValues()
        //             Shopify.theme.jsProcessTimeline.updateHash($section)
        //             //}
        //         })



    },
    updateHash: function($section) {
        let navlist = Shopify.theme.jsProcessTimeline.navList($section)
        if ($('#mobile-header').hasClass('sticky--enabled')) {
            $('.process__page-timeline.timeline .nav li a').css('top', '120px')
        } else {
            $('.process__page-timeline.timeline .nav li a').css('top', '20px')

        }
        $.each(navlist, function(e, elem) {
            var placement = elem.target[0].getBoundingClientRect();
            if (
                (placement.top - $('#mobile-header').height() < 0) &&
                (placement.top - $('#mobile-header').height() + placement.height > 0)
            ) {
                //history.pushState({}, '', elem.id);
                $section.find(".timeline--item").removeClass('active')
                $section.find(`.timeline--item [href="${elem.id}"]`).parent()
                    .addClass('active')

                return false; /* Exit $.each loop */
            } else {
                $section.find(".timeline--item").removeClass('active')
                //return false;
            }
        });
        //         let currentActive = $section.find('li.timeline--item.active').index()
        //         let scrollY = $(window)[0].scrollY

        //         if (currentActive > -1 && navlist[currentActive]) {
        //             let currentTop = navlist[currentActive].target.offset().top
        //             let currentHeight = navlist[currentActive].target.height()
        //             let $headerHeight = 20
        //             if($('.sticky--enabled').length){
        //             	$headerHeight = $('#mobile-header').height()
        //             }
        //             if (
        //                 scrollY < currentTop + currentHeight - $headerHeight
        //             ) {
        //               if(scrollY - currentTop + $headerHeight > 0)
        //                 $section.find('li.timeline--item.active a').css('top', (scrollY - currentTop + $headerHeight) + 'px')
        //             } else {
        //                 if (scrollY - currentTop + $('#mobile-header').height() > 0) {
        //                     $section.find('li.timeline--item.active a').css('top', currentHeight + 'px')

        //                 } else if (scrollY < currentTop + currentHeight - $headerHeight) {
        //                     $section.find('li.timeline--item.active a').css('top', '0px')

        //                 }
        //             }
        //         }
    },
    unload: function unload($section) {
        history.pushState({}, '', '')
        let $tabs = $section.parent('.process__page-tabs')
        $section.find(".timeline--item a").off('click')
        Shopify.theme.jsProcessTimeline.resetTop()
        $section.find(".timeline--item a").removeClass('active')
        Shopify.theme.jsProcessTimeline.navList()

    }
}